import axios from 'axios';

//imported
import store from '../store';
import { authLogout } from '../store/actions/auth';

// Create instance
const axiosInstance = axios.create();

export const setAxiosAccessToken = (token) => {
  axiosInstance.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
  axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
}

const access_token = localStorage.getItem('access_token');
setAxiosAccessToken(access_token);

// Axios wrapper to handle error
const axiosWrapper = apiCall => apiCall.then(res => res.data).catch(err => Promise.reject(err));

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
         store.dispatch(authLogout());
    }
    if (error?.response && error?.response?.data?.message === null) {
      store.dispatch(authLogout());
    }
    if (error?.response && error.response?.data?.message === 'Missing Authentication Token') {
      store.dispatch(authLogout());
    }
    if (error?.response && error.response?.data?.message === 'Invalid Authentication Token Format') {
      store.dispatch(authLogout());
    }
    if (error?.response && error.response?.data?.message === 'User Not Authorized') {
      store.dispatch(authLogout());
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;